module.exports = require('./helpers/bundle-url').getBundleURL('5D0wD') + "1F620.49614bd7.svg";